import React, { FC, HTMLAttributes } from "react"

const CardBody: FC<HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    ...htmlProps
}: React.HTMLAttributes<HTMLDivElement>) => {
    const klass = `zb-card-body ${className || ""}`

    return (
        <div className={klass} {...htmlProps}>
            {children}
        </div>
    )
}

export default CardBody
